import { Component, OnInit, Input } from '@angular/core';
import { Order } from '../order-list/models/order';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html'
})
export class OrderDetailsComponent implements OnInit {


  @Input() order: Order;


  constructor(private messagesService: MessagesService) {

    console.log("from details : " + this.order);

  }

  ngOnInit() {
  }

}
